"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gen_run_waitForPlayerFling = void 0;
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var vecUtil_sidecar_1 = require("@lib/vecUtil-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var minigolfCamera_sidecar_1 = require("../camera/minigolfCamera-sidecar");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var minigolfCreatures_sidecar_1 = require("../entities/minigolfCreatures-sidecar");
var minigolfHoles_sidecar_1 = require("../entities/minigolfHoles-sidecar");
var physicsTickManager_sidecar_1 = require("../to-engine/physicsTickManager-sidecar");
var minigolfGameState_1 = require("./minigolfGameState");
var minigolfGameState_sidecar_1 = require("./minigolfGameState-sidecar");
var minigolfMainGameGenerator_sidecar_1 = require("./minigolfMainGameGenerator-sidecar");
function gen_run_waitForPlayerFling() {
    var elapsed, currentPuck, cameraTarget, pos, closestHole, holeAdjustX, holeAdjustY, holePos, dist, maxAdjust, max, vec, posAdj;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                minigolfGameState_sidecar_1.minigolfGameState.get().state = minigolfGameState_1.MinigolfGameStates.waitForPlayerFling;
                minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.get().signal_flung = false;
                physicsTickManager_sidecar_1.physicsTickManager.setIsRunning(true);
                elapsed = 0;
                minigolfGameState_sidecar_1.minigolfGameState.get().playerState.gameStateString = 'Player turn';
                _a.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 3];
                currentPuck = minigolfGameState_sidecar_1.minigolfGameState.getCurrentPlayer();
                if (!minigolfGameState_sidecar_1.minigolfGameState.getCurrentPlayer()) {
                    currentPuck = minigolfCreatures_sidecar_1.minigolfCreatures
                        .getAll()
                        .filter(function (c) { return c.data.isPuck && !c.isDead; })[0];
                    if (currentPuck) {
                        minigolfGameState_sidecar_1.minigolfGameState.get().currentPuck = currentPuck;
                    }
                    else {
                        minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                        return [2 /*return*/, 0];
                    }
                }
                minigolfCreatures_sidecar_1.minigolfCreatures.fadeOutNoHealthnemies();
                if (minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.isExitToLevelGenSignaled()) {
                    return [2 /*return*/, 0];
                }
                if (minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.get().signal_flung) {
                    // Reset slow immune
                    minigolfCreatures_sidecar_1.minigolfCreatures.getAll().forEach(function (c) {
                        c.state.slowImmuneThisTurn = false;
                    });
                    return [2 /*return*/, 0];
                }
                // Check health
                if (minigolfGameState_sidecar_1.minigolfGameState.get().playerState.health <= 0 &&
                    !minigolfDefs_sidecar_1.minigolfDefs.debug_disallowDeath) {
                    if (!minigolfGameState_sidecar_1.minigolfGameState.get().playerState.didLose) {
                        minigolfGameState_sidecar_1.minigolfGameState.get().playerState.didLose = true;
                        minigolfGameState_sidecar_1.minigolfGameState.get().playerState.deathReason =
                            minigolfGameState_sidecar_1.minigolfGameState.get().playerState.lastDamage;
                    }
                    return [2 /*return*/, 0];
                }
                elapsed += common_sidecar_1.common.getUpdateDelta();
                // let currentPlayer = minigolfGameState.getCurrentPlayer()
                // if (currentPlayer) {
                //   minigolfCreatures.say(currentPlayer, 'waiting for fling...')
                // }
                if (elapsed < 1.5 && !minigolfDefs_sidecar_1.minigolfDefs.debug_dontAutoCamera) {
                    cameraTarget = minigolfGameState_sidecar_1.minigolfGameState.getCurrentPlayer();
                    if (cameraTarget && !cameraTarget.isDead) {
                        pos = cameraTarget.rigidBody.translation();
                        closestHole = minigolfHoles_sidecar_1.minigolfHoles.findClosestTo(pos.x, pos.y);
                        holeAdjustX = 0;
                        holeAdjustY = 0;
                        if (!closestHole) {
                            console.log('no hole found');
                        }
                        if (closestHole) {
                            holePos = closestHole.rigidBody.translation();
                            dist = mathUtils_sidecar_1.mathUtils.distance(pos.x, pos.y, holePos.x, holePos.y);
                            maxAdjust = dist / 2;
                            max = 3;
                            if (maxAdjust > max) {
                                maxAdjust = max;
                            }
                            vec = vecUtil_sidecar_1.vecUtil.deltaTowardsXY(pos, holePos, maxAdjust);
                            holeAdjustX = vec.x;
                            holeAdjustY = vec.y;
                        }
                        posAdj = minigolfCamera_sidecar_1.minigolfCamera.physicsToCamera(pos.x + holeAdjustX, pos.y + holeAdjustY);
                        voyageCamera_sidecar_1.voyageCamera.easeToCenterOn(posAdj.x, posAdj.y, 1 / 60);
                    }
                }
                // console.log('waiting for fling...')
                return [4 /*yield*/, 0];
            case 2:
                // console.log('waiting for fling...')
                _a.sent();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/, 0];
        }
    });
}
exports.gen_run_waitForPlayerFling = gen_run_waitForPlayerFling;
